import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import introduce from '@/components/introduce'
import news from '@/components/news'
import character from '@/components/character'
import paper from '@/components/paper'
import notice from '@/components/notice'
import member from '@/components/member'
import service from '@/components/service'
import join from '@/components/join'
import newsArticle from '@/components/article/newsArticle'
import paperArticle from '@/components/article/paperArticle'
import noticeArticle from '@/components/article/noticeArticle'
import onload from '@/components/onload'
import apply from '@/components/apply'
import individualApply from '@/components/individualApply'
import enterpriseApply from '@/components/enterpriseApply'
import joinProcess from '@/components/joinProcess'
import enterpriseApplyAgain from '@/components/enterpriseApplyAgain'
import individualApplyAgain from '@/components/individualApplyAgain'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    // 学会首页
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: '广东省仪器仪表学会'
      }
    },
    // 学会介绍
    {
      path: '/introduce',
      name: 'introduce',
      component: introduce
    },
    // 学会新闻
    {
      path: '/news',
      name: 'news',
      component: news
    },
    // 学会人物
    {
      path: '/character',
      name: 'character',
      component: character
    },
    // 学会论文
    {
      path: '/paper',
      name: 'paper',
      component: paper
    },
    // 站内通知
    {
      path: '/notice',
      name: 'notice',
      component: notice
    },
    // 会员地址
    {
      path: '/member',
      name: 'member',
      component: member
    },
    // 学会服务
    {
      path: '/service',
      name: 'service',
      component: service
    },
    // 加入学会
    {
      path: '/join',
      name: 'join',
      component: join
    },
    // 新闻文章
    {
      path: '/newsArticle/:id/:tab',
      name: 'newsArticle',
      component: newsArticle
    },
    // 论文文章
    {
      path: '/paperArticle/:id/:tab',
      name: 'paperArticle',
      component: paperArticle
    },
    // 通知文章
    {
      path: '/noticeArticle/:id/:tab',
      name: 'noticeArticle',
      component: noticeArticle
    },
    // 登录
    {
      path: '/onload',
      name: 'onload',
      component: onload
    },
    // 会员申请
    {
      path: '/apply',
      name: 'apply',
      component: apply
    },
    // 个人会员申请
    {
      path: '/individualApply',
      name: 'individualApply',
      component: individualApply
    },
    // 企业会员申请
    {
      path: '/enterpriseApply',
      name: 'enterpriseApply',
      component: enterpriseApply
    },
    // 申请流程
    {
      path: '/joinProcess',
      name: 'joinProcess',
      component: joinProcess
    },
    // 企业会员重新申请
    {
      path: '/enterpriseApplyAgain',
      name: 'enterpriseApplyAgain',
      component: enterpriseApplyAgain
    },
    // 个人会员重新申请
    {
      path: '/individualApplyAgain',
      name: 'individualApplyAgain',
      component: individualApplyAgain
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js